// Static JSON data service - loads from public/data/ directory
// Used when REACT_APP_USE_STATIC_DATA=true

const DATA_BASE_PATH = window.location.hostname.includes('sandpack') ? 'public/data' : '/data';

export const staticDataService = {
  async getAll(entity, params = {}) {
    try {
      const response = await fetch(`${DATA_BASE_PATH}/${entity}.json`);
      if (!response.ok) throw new Error(`Failed to load ${entity}`);
      let data = await response.json();

      if (params.search) {
        const q = params.search.toLowerCase();
        data = data.filter(item => JSON.stringify(item).toLowerCase().includes(q));
      }

      if (params.page && params.limit) {
        const start = (params.page - 1) * params.limit;
        const end = start + params.limit;
        data = data.slice(start, end);
      }

      return data;
    } catch (error) {
      console.error(`Failed to load ${entity}:`, error);
      return [];
    }
  },

  async getById(entity, id) {
    const data = await this.getAll(entity);
    return data.find(item => item.id === parseInt(id)) || null;
  },

  async create(entity, newData) {
    console.log(`Static mode: CREATE ${entity}`, newData);
    const generatedData = {
      ...newData,
      id: Date.now(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    return Promise.resolve(generatedData);
  },

  async update(entity, id, updateData) {
    console.log(`Static mode: UPDATE ${entity}/${id}`, updateData);
    return Promise.resolve({
      ...updateData,
      id: parseInt(id),
      updatedAt: new Date().toISOString()
    });
  },

  async delete(entity, id) {
    console.log(`Static mode: DELETE ${entity}/${id}`);
    return Promise.resolve({ success: true, id: parseInt(id) });
  }
};
